
import { useRoute, useRouter } from "vue-router";
import Icon from "../../../components/icon/index.vue";
import Navbar from "../../../components/navbar.vue";
import PhotoManager from "../../../components/photo-manager.vue";
import { useUserStore } from "../../../stores/user";
import { inject } from "vue";
import { venueImagesKey } from "../../../keys";

export default {
  name: "ManagePhotos",
  components: {
    Icon,
    Navbar,
    PhotoManager,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const user = useUserStore();
    const venueImages = inject(venueImagesKey);

    async function submit() {
      await venueImages.value.$update();
      router.push({
        name: "editVenueAddress",
        params: { venueId: route.params.venueId },
      });
    }

    return {
      route,
      user,
      venueImages,
      submit,
    };
  },
};
